import Spinner from "./Spinner";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <Spinner size="lg" />
    </div>
  );
};

export default Loader;
